import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=1f1741ab&scoped=true&"
import script from "./BackToTop.vue?vue&type=script&lang=js&"
export * from "./BackToTop.vue?vue&type=script&lang=js&"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=1f1741ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1741ab",
  null
  
)

export default component.exports